<template>
    <button class="back_button" @click="HistoryBack">{{txt}}</button>
</template>
<script>
// import config from '@/config/index.js'
// const Base64 = require('js-base64').Base64

export default {

  name: 'Menu',
  components: {
  },
  props: {
    txt: {
      type: String,
      default: "上一步"
    },
  },
  data() {
    return {
    }
  },
  created(){
    
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll)
  },
  filters: {
    
  },
  methods: {
    HistoryBack(){
      window.history.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.back_button
  {
    background: $--btn_color;
    width: 1.9rem;
    height: 0.5rem;
    font-size: 0.24rem;
    color: #fff;
    border: 0.01rem solid #797979;
    border-radius: 0.07rem;
    margin-right: 0.5rem;
  }
</style>